export default __webpack_public_path__ + "static/media/dropshipping-model-rafiki.33760869.png";